module.exports = __webpack_public_path__ + "img/takedabg.cbc188ee.png";